import Slider from '../components/Slider';
import BackgroundImage from '../core/BackgroundImage';

const defaults = {
  wrapAround: true,
  pageDots: true,
  prevNextButtons: true,
  autoPlay: true,
  adaptiveHeight: false,
  groupCells: 1,
  // responsive: {
  //   desktop: {
  //     prevNextButtons: true,
  //   },
  //   desktop_xl: {
  //     prevNextButtons: true,
  //   },
  // },
};

export default class Featured {
  constructor(element) {
    this.element = element;
    this.settings = defaults;
    this.Slider = new Slider(this.container, this.settings);
    this.init();
    this.ready();
  }

  init() {
    this.element.querySelectorAll('.node-home-featured').forEach((elem) => {
      if (elem && !elem.bg) {
        elem.bg = new BackgroundImage(elem, {
          destSelector: '.node-image',
        });
      }
    });
  }

  ready() {
    setTimeout(() => {
      this.element.classList.add('ready');
    }, 200);
  }

  get container() {
    return this.element.querySelector('.block-content');
  }
}
